export default "__VITE_ASSET__3ecca93d__"